import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { updateCart, removeCart } from "../../actions/cart";
import DeleteIcon from "../../assets/img/delete_icon.svg";
// import NoImage from "../../assets/img/unavailable.svg";

const StyledQtyButton = styled.button`
  ${props => props.brand && `
    background: ${props.brand.colors.theme} !important;
    border: ${props.brand.colors.theme} !important;

    &:hover {
      background: ${props.brand.colors.cartBackground} !important;
      border: ${props.brand.colors.cartBackground} !important;
    }
  `}
`;

const StyledUpdateButton = styled.button`
  ${props => props.brand && `
    &:not(:disabled) {
      background: ${props.brand.colors.theme} !important;
      border: ${props.brand.colors.theme} !important;

      &:hover {
        background: ${props.brand.colors.cartBackground} !important;
        border: ${props.brand.colors.cartBackground} !important;
      }
    }
  `}
`;

const StyledTable = styled.table`
  td, th {
    vertical-align: middle !important;
    
    span, div {
      display: flex;
      align-items: center;
      line-height: 1.2;
    }
  }
  
  .product-number, .product-ndc, .product-name, 
  .product-manufacturer, .product-size, .product-price {
    display: flex;
    align-items: center;
    min-height: 24px;
  }
  
  .delete-btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    
    &:hover {
      opacity: 0.7;
    }
  }
`;

export const ItemList = ({ page, brand }) => {
  const user = JSON.parse(localStorage.getItem("profile"));
  const cart = useSelector((state) => state.cart);
  const [selectedItem, setSelectedItem] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [localCartData, setLocalCartData] = useState([]);
  const dispatch = useDispatch();

  // Initialize local cart data from Redux store
  useEffect(() => {
    if (cart.countData) {
      setLocalCartData([...cart.countData]);
    }
  }, [cart.countData]);

  // Add debounce function to limit API calls
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  // Debounced version of updateCart API call
  const debouncedUpdateCart = React.useCallback(
    debounce((productId, newQuantity) => {
      if (user?.username) {
        setIsLoading(true);
        const product = {
          productId,
          quantity: newQuantity,
        };
        dispatch(updateCart(user.username, product));
      }
    }, 800), // 800ms delay
    [user?.username, dispatch]
  );

  const handleQtyUpdate = (item, action) => {
    let newQuantity;
    
    if (!selectedItem || item.productId !== selectedItem.productId) {
      setSelectedItem(item);
      newQuantity = action === "add" ? item.quantity + 1 : item.quantity - 1;
      
      if (newQuantity <= 0) {
        handleDelete(item);
        return;
      }
      
      setQuantity(newQuantity);
    } else {
      newQuantity = action === "add" ? quantity + 1 : quantity - 1;
      
      if (newQuantity <= 0) {
        handleDelete(item);
        return;
      }
      
      setQuantity(newQuantity);
    }
    
    // Update local cart data for real-time total calculation
    updateLocalCartData(item.productId, newQuantity);
    
    // Auto-update cart in backend after a delay
    debouncedUpdateCart(item.productId, newQuantity);
  };

  const handleQtyInput = (e, item) => {
    const inputValue = e.target.value;
    
    // Always set the selected item
    if (!selectedItem || item.productId !== selectedItem.productId) {
      setSelectedItem(item);
    }
    
    // Allow empty input for typing
    if (inputValue === '') {
      setQuantity('');
      return;
    }
    
    const value = parseInt(inputValue);
    
    // Only update if it's a valid non-negative number
    if (!isNaN(value) && value >= 0) {
      setQuantity(value);
      
      // Update local cart data for real-time total calculation
      updateLocalCartData(item.productId, value);
      
      // Auto-update cart in backend after a delay
      debouncedUpdateCart(item.productId, value);
    }
  };

  // Helper function to update local cart data
  const updateLocalCartData = (productId, newQuantity) => {
    const updatedCart = localCartData.map(item => 
      item.productId === productId 
        ? { ...item, quantity: newQuantity } 
        : item
    );
    
    setLocalCartData(updatedCart);
    
    // Dispatch a temporary update to the cart state for real-time total calculation
    // This doesn't make an API call, just updates the Redux store
    dispatch({ 
      type: 'UPDATECOUNT', 
      payload: updatedCart 
    });
  };

  // Removed handleUpdate function as it's no longer needed

  const handleDelete = (item) => {
    setSelectedItem(item);
    setIsLoading(true);
    dispatch(removeCart(user?.username, parseInt(item.productId)));
  };

  useEffect(() => {
    setIsLoading(false);
    setSelectedItem(null);
    setQuantity(1);
  }, [cart]);

  return (
    <>
      {/* {cart.countData?.map((cartItem) => (
        <div
          key={`key` + cartItem.productId}
          className="product d-flex align-items-center"
        >
          {isLoading && selectedItem === cartItem && (
            <div className="loader-container">
              <div className="spinner-border text-light" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
          <div className="img-container">
            <img
              className="product-image"
              src={cartItem.imageUrl ? cartItem.imageUrl : NoImage}
              alt=""
            />
          </div>
          <div className="info-container">
            {page === "cart" && (
              <div className="d-flex justify-content-end action-container">
                <div
                  className="delete-btn"
                  onClick={() => handleDelete(cartItem)}
                >
                  <img
                    src={require("../../assets/img/delete_icon.svg")}
                    alt=""
                  />
                </div>
              </div>
            )}
            <div className="d-flex align-items-center justify-content-between details-container">
              <div>
                <p className="product-name">{cartItem.productName}</p>
                <p className="variant">NDC: {cartItem.ndc}</p>
                <p
                  className={
                    "availability " +
                    (cartItem?.totalquantityonhand &&
                    cartItem?.totalquantityonhand !== "" &&
                    cartItem?.totalquantityonhand !== "0.0"
                      ? ""
                      : "no-stock")
                  }
                >
                  {cartItem?.totalquantityonhand !== "" &&
                  cartItem?.totalquantityonhand !== "0.0"
                    ? ""
                    : "Item is out of stock."}
                </p>
                <p className="price">${cartItem.price.toFixed(2)}</p>
              </div>
              {page === "cart" ? (
                <div className="d-flex align-items-center qty-action-container">
                  <div className="d-flex align-items-center qty-container">
                    <button
                      className="minus-btn"
                      onClick={() => handleQtyUpdate(cartItem, "minus")}
                    >
                      -
                    </button>
                    <input
                      type="number"
                      value={
                        selectedItem?.productId === cartItem.productId
                          ? quantity
                          : cartItem.quantity
                      }
                      onChange={(e) => handleQtyInput(e, cartItem)}
                    />
                    <button
                      className="plus-btn"
                      onClick={() => handleQtyUpdate(cartItem, "add")}
                    >
                      +
                    </button>
                  </div>
                  {selectedItem?.productId === cartItem.productId &&
                    !isLoading && (
                      <button className="update-btn" onClick={handleUpdate}>
                        Update
                      </button>
                    )}
                </div>
              ) : (
                <p className="quantity">x{cartItem.quantity}</p>
              )}
            </div>
          </div>
        </div>
      ))} */}
        <h2>Cart Items</h2>
        <StyledTable className="w-100">
            <thead>
                <tr className="table-header">
                    <th>
                        <div className="d-flex align-items-center justify-content-start">Item No / NDC</div>
                    </th>
                    <th>
                        <div className="d-flex align-items-center justify-content-start">
                            Description
                        </div>
                    </th>
                    <th>
                        <div className="d-flex align-items-center justify-content-start">Manufacturer</div>
                    </th>
                    <th>
                        <div className="d-flex align-items-center justify-content-start">
                            Size
                        </div>
                    </th>
                    <th>
                        <div className="d-flex align-items-center justify-content-start">
                            Price
                        </div>
                    </th>
                    <th>
                        <div className="d-flex align-items-center justify-content-center">
                            Qty
                        </div>
                    </th>
                    <th>
                        <div className="d-flex align-items-center justify-content-center">
                            Remove
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                {
                    cart.countData?.map(cartItem => {
                        return <tr key={cartItem.productId}>
                            <td className="d-flex flex-column align-items-start justify-content-center">
                                {
                                    isLoading
                                    && selectedItem === cartItem
                                    && <div className="loader-container">
                                        <div className="spinner-border text-light" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                }
                                <span className="product-number">{cartItem.productNumber}</span>
                                <div className="product-ndc">{cartItem.ndc}</div>
                            </td>
                            <td>
                                <span className="product-name">
                                    {cartItem.productName}
                                </span>
                            </td>
                            <td>
                                <span className="product-manufacturer">
                                    {cartItem.manufacturer}
                                </span>
                            </td>
                            <td>
                                <div className="d-flex align-items-center">
                                    <span className="product-size">
                                        {cartItem.bottleSize}
                                    </span>
                                </div>
                            </td>
                            <td>
                                <span className="product-price">
                                    $ {cartItem.price}
                                </span>
                            </td>
                            <td>
                                <div className="product-quantity d-flex align-items-center justify-content-center">
                                {page === "cart" || page === "checkout" ? (
                                    <div className="d-flex align-items-center qty-action-container">
                                        <div className="d-flex align-items-center qty-container">
                                            <StyledQtyButton
                                                brand={brand}
                                                className="minus-btn"
                                                onClick={() => handleQtyUpdate(cartItem, "minus")}
                                            >
                                                -
                                            </StyledQtyButton>
                                            <input
                                                type="number"
                                                min="0"
                                                value={
                                                    selectedItem?.productId === cartItem.productId
                                                    ? quantity
                                                    : cartItem.quantity
                                                }
                                                onChange={(e) => handleQtyInput(e, cartItem)}
                                            />
                                            <StyledQtyButton
                                                brand={brand}
                                                className="plus-btn"
                                                onClick={() => handleQtyUpdate(cartItem, "add")}
                                            >
                                                +
                                            </StyledQtyButton>
                                        </div>
                                    </div>
                                ) : <>{cartItem.quantity}</>
                                }
                                </div>
                            </td>
                            <td>
                                <div className="d-flex flex-row align-items-center justify-content-center">
                                    <span
                                        className="delete-btn d-flex align-items-center justify-content-center"
                                        onClick={() => handleDelete(cartItem)}
                                        title="Remove item"
                                    >
                                        <img
                                            src={DeleteIcon}
                                            alt="Remove item"
                                        />
                                    </span>
                                </div>
                            </td>
                        </tr>
                    })
                }
            </tbody>
        </StyledTable>
        {
            (!cart.countData || cart.countData?.length <= 0)
            && <div className="d-flex align-items-center justify-content-center cart-empty">
                Your Cart is Empty
            </div>
        }
    </>
  );
};
